import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { WebPageShell } from '../components/common/WebPageShell';
import { StoreContent } from '../components/store/StoreContent';
import { useTheme } from '../context/ThemeContext';

/** The school store — web layout with the sidebar shell. */
export function StoreScreen() {
  const { colors } = useTheme();

  return (
    <WebPageShell title="Store">
      <View style={styles.header}>
        <Text style={[styles.title, { color: colors.textPrimary }]}>School Store</Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
          Order uniforms, stationery and supplies — pay and collect at the school office.
        </Text>
      </View>
      <StoreContent />
    </WebPageShell>
  );
}

const styles = StyleSheet.create({
  header: { marginBottom: 16 },
  title: { fontSize: 22, fontWeight: '800' },
  subtitle: { fontSize: 13, marginTop: 4 },
});
